import React, { Component } from "react";
import {
  Drawer,
  Form,
  Button,
  Col,
  Row,
  Input,
  Select,
  DatePicker,
  notification,
  Space,
  Spin
} from "antd";
import { PlusOutlined } from "@ant-design/icons";
import "../styles/general.css";

import { MakeRequestAsync } from "../functions/axios";
import { POST, GET, UPDATE } from "../constants/request-type";
import { service_api } from "../constants/url";
import {
  country,
  get_all_country,
  user,
  create_user,
  update_user,
  check_tag,
  card,
  province,
  get_all_province,
  city,
  get_all_city,
  zip,
  get_all_zip
  // update_password_user
} from "../constants/routes";
import { openNotificationWithIcon } from "../functions/notification";
import { raw_menu } from "../constants/raw-list";
import {
  EmailValidation,
  PasswordValidation
} from "../functions/validateEmailPassword";
import { uploadFile } from "../functions/upload-file";
import { AiFillMinusCircle } from "react-icons/ai";
import { MdVerified } from "react-icons/md";
import { decryptSingleData } from "../functions/cryptojs";

const token = sessionStorage.getItem("auth_token");

const { Option } = Select;

class Article_edit extends Component {
  state = {
    visible: false,
    name: this.props.row.name,
    description: this.props.row.description,
    weight_type: this.props.row.weight_type,
    cost: this.props.row.cost,
    weight: this.props.row.weight,
    category_id: this.props.row.category,
    list: [],
    pic: null,
    load: false
  };

  componentDidMount() {
    this.getData();
  }
  handleChange = (e) => {
    e.preventDefault();
    this.setState({ [e.target.name]: e.target.value });
  };
  handleImage = (e) => {
    e.preventDefault();
    return this.setState({ pic: e.target.files[0] });
  };
  getData = async () => {};

  handleSubmit = async (e) => {
    e.preventDefault();

    const { name, description, weight_type, cost, category_id, weight, pic } =
      this.state;

    const data = {
      name,
      cost,
      weight_type,
      weight,
      description,
      category: category_id,
      pic
    };

    if (
      name === "" ||
      description === "" ||
      weight_type === "" ||
      category_id === null
    ) {
      return openNotificationWithIcon("error", "You must fill all inputs");
    }
    if (cost < 0 || weight < 0) {
      return openNotificationWithIcon(
        "error",
        "Weight & Cost should be above zero"
      );
    }

    this.setState({ load: true });

    let pic_url;

    if (pic !== null) {
      pic_url = await uploadFile(pic);

      if (!pic_url.data.success) {
        this.setState({ load: false });
        return openNotificationWithIcon(
          "error",
          "An error has occured while uploading the image, please try again"
        );
      }
    }

    const request_details = {
      type: UPDATE,
      url: service_api,
      route: "glocery-item/update-glocery-item/" + this.props.row._id,
      data: {
        ...data,
        pic: pic !== null ? pic_url.data.url : this.props.row.pic
      },
      token: token
    };

    const response = await MakeRequestAsync(request_details).catch((err) => {
      console.log(err);
      this.setState({ load: false });
      return openNotificationWithIcon("error", err);
    });

    return setTimeout(() => window.location.reload(), 0);
  };

  showDrawer = () => {
    this.setState({
      visible: true
    });
  };

  onClose = () => {
    this.setState({
      visible: false
    });
  };

  render() {
    const {
      name,
      cost,
      weight_type,
      weight,
      description,
      category_id,
      pic,
      list,
      load
    } = this.state;
    return (
      <>
        <Button type="danger" onClick={this.showDrawer}>
          Edit
        </Button>
        <Drawer
          title="Edit an article"
          width={720}
          onClose={this.onClose}
          visible={this.state.visible}
          bodyStyle={{ paddingBottom: 80 }}
          footer={
            <div
              style={{
                textAlign: "right"
              }}
            >
              {load ? (
                <Space size="middle">
                  <Spin size="large" />
                </Space>
              ) : (
                <div>
                  <Button onClick={this.onClose} style={{ marginRight: 8 }}>
                    Retour
                  </Button>
                  <Button
                    onClick={(e) => {
                      this.handleSubmit(e);
                    }}
                    type="primary"
                  >
                    Soumettre
                  </Button>
                </div>
              )}
            </div>
          }
        >
          <Form layout="vertical" hideRequiredMark>
            <Row gutter={16}>
              <Col span={24}>
                <Form.Item
                  label="Article name"
                  rules={[
                    {
                      required: true,
                      role: "Article name"
                    }
                  ]}
                >
                  <Input
                    name="name"
                    placeholder="Article name"
                    onChange={this.handleChange}
                    value={name}
                  />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  label="Description"
                  rules={[
                    {
                      required: true,
                      role: "Description"
                    }
                  ]}
                >
                  <Input.TextArea
                    name="description"
                    rows={4}
                    placeholder="Description"
                    onChange={this.handleChange}
                    value={description}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  label="Cost ($)"
                  rules={[
                    {
                      required: true,
                      role: "Enter cost"
                    }
                  ]}
                >
                  <Input
                    name="cost"
                    type="weight"
                    placeholder="Enter cost"
                    onChange={this.handleChange}
                    value={cost}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="Catégorie de l'article">
                  <Select
                    allowClear
                    style={{ width: "100%" }}
                    placeholder="Catégorie de l'article"
                    defaultValue={category_id}
                    onChange={(data) => {
                      return this.setState({ category_id: data });
                    }}
                    options={this.props.category?.map((item) => {
                      return {
                        label: `${item?.name} (${item?.eng_name})`,
                        value: item?._id
                      };
                    })}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  label="Weight type"
                  rules={[
                    {
                      required: true,
                      role: "weight type"
                    }
                  ]}
                >
                  <Select
                    allowClear
                    style={{ width: "100%" }}
                    placeholder="Weight type"
                    defaultValue={weight_type}
                    onChange={(data) => {
                      return this.setState({ weight_type: data });
                    }}
                    options={[
                      { label: "g", value: "g" },
                      { label: "kg", value: "kg" }
                    ]}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  label="Article Weight (g/kg)"
                  rules={[
                    {
                      required: true,
                      role: "Weight"
                    }
                  ]}
                >
                  <Input
                    name="weight"
                    type="weight"
                    placeholder="weight"
                    onChange={this.handleChange}
                    value={weight}
                  />
                </Form.Item>
              </Col>

              <Col span={12}>
                <Form.Item
                  name="icon"
                  label="Icon"
                  rules={[
                    {
                      required: true,
                      message: "Upload is required"
                    }
                  ]}
                >
                  <Input
                    type="file"
                    // multiple={true}
                    accept="image/x-png,image/jpeg,image/jpg"
                    placeholder="Upload picture"
                    onChange={this.handleImage}
                    value={pic}
                    name="pic"
                  />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Drawer>
      </>
    );
  }
}

export default Article_edit;
